export const menuTypes = {
  DASHBOARD: 'dashboardMenu',
  SCENARIOS: 'scenarios',
  PROVISION: 'taxProvisionMenu',
  BALANCE_SHEET: 'balanceSheetMenu',
  REPORTS: 'reportsMenu',
  RETURN_TO_PROVISION: 'rtpMenu',
  USER: 'userMenu',
  GEAR: 'gear',
  ADMINISTRATION: 'administration',
  SUPPORT: 'support',
};

export const menuTooltipContainerId = 'menu-tooltips-container';
